<template>
  <div>
    <HeaderIcons :selectedItems="selectedItems" type="moveLoadTableData" @getData="reloadPage" />

    <div v-if="!this.$store.state.allLoading" style="margin-top: 40px">
      <!-- Success/Error Message -->
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" bottom right>
        {{ snackbar.message }}
      </v-snackbar>

      <div class="table__view">
        <table-component :showSelect="false" itemKey="id" :selectedRows.sync="selected_requests" :headers="headers"
          :pagination="this.$store.state.pagination" :limit="$store.state.counterOfShow"
          :items="this.$store.state.tableData" :loading="loading" @refresh="getTableData" v-model="page"
          :fixed-header="true" table-height="calc(100vh - 220px)">
          <!-- Action Column -->
          <template v-slot:[`item.operations`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="white" small depressed dark v-bind="attrs" v-on="on">
                  <v-icon style="background: rgb(63, 14, 64); border-radius: 4px">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <AllSingleProcess :item="item" @getUsersName="getUsersName" @reloadData="getTableData(1)" />
              </v-list>
            </v-menu>
          </template>

          <!-- Editable Customer Name -->
          <template v-slot:[`item.customerName`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="text" :value="item.customerName"
                @blur="updateField(item, 'cust_name', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.customerName }}</span>
          </template>

          <!-- Editable Payment Cost -->
          <template v-slot:[`item.mortCost`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.mortCost" @blur="updateField(item, 'mortCost', $event.target.value)"
                class="editable-input" />
            </div>
            <span v-else>{{ item.mortCost }}</span>
          </template>

          <!-- Editable Notes -->
          <template v-slot:[`item.accountcomment`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <textarea :value="item.accountcomment" @blur="updateComment(item, $event.target.value)"
                class="editable-textarea" rows="2"></textarea>
            </div>
            <span v-else>{{ item.accountcomment }}</span>
          </template>

          <!-- Editable Wsata Mortgage -->
          <template v-slot:[`item.mortgage_value`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.mortgage_value"
                @blur="updateField(item, 'mortgage_value', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.mortgage_value }}</span>
          </template>

          <!-- Editable Tsaheel Mortgage -->
          <template v-slot:[`item.tsaheel_mortgage_value`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.tsaheel_mortgage_value"
                @blur="updateField(item, 'tsaheel_mortgage_value', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.tsaheel_mortgage_value }}</span>
          </template>

          <!-- Editable Start Date -->
          <template v-slot:[`item.recived_date_report_mor`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <v-menu ref="startDateMenu" v-model="item.startDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="item.recived_date_report_mor || ''"
                    :placeholder="!item.recived_date_report_mor ? 'اختر التاريخ' : ''" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on" dense outlined hide-details></v-text-field>
                </template>
                <v-date-picker :value="item.recived_date_report_mor || null"
                  @input="updateStartDate(item, $event); item.startDateMenu = false" no-title
                  scrollable></v-date-picker>
              </v-menu>
            </div>
            <span v-else>{{ item.recived_date_report_mor || '---' }}</span>
          </template>

          <!-- Editable End Date -->
          <template v-slot:[`item.to_date`]="{ item }">
            <div v-if="canEditToDate(item)" class="editable-field">
              <v-menu ref="endDateMenu" v-model="item.endDateMenu" :close-on-content-click="false"
                transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="getEditableToDate(item) || ''"
                    :placeholder="!getEditableToDate(item) ? 'اختر التاريخ' : ''"
                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined
                    hide-details></v-text-field>
                </template>
                <v-date-picker :value="getEditableToDate(item)"
                  @input="updateEndDate(item, $event); item.endDateMenu = false" :min="item.recived_date_report_mor"
                  no-title scrollable></v-date-picker>
              </v-menu>
            </div>
            <div v-else-if="canEdit(item) && !item.recived_date_report_mor" class="editable-field">
              <v-text-field value="---" prepend-icon="mdi-calendar" readonly disabled dense outlined
                hide-details></v-text-field>
            </div>
            <span v-else>{{ formatDisplayToDate(item) }}</span>
          </template>

          
          <!-- Editable Nature of Transaction -->
          <template v-slot:[`item.natureRequest`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <select :value="item.natureRequest" @change="updateField(item, 'natureRequest', $event.target.value)"
                class="editable-select">
                <option value="">اختر طبيعة المعاملة</option>
                <option v-for="option in natureRequestOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <span v-else>{{ item.natureRequest }}</span>
          </template>

          <!-- Duration Display -->
          <template v-slot:[`item.counter_report_mor`]="{ item }">
            <span>{{ item.counter_report_mor }}</span>
          </template>

          <!-- Approval Status Columns -->
          <template v-slot:[`item.is_approved_by_wsata_acc`]="{ item }">
            <v-icon v-if="item.is_approved_by_wsata_acc === 'نعم'" color="green">mdi-check-circle</v-icon>
            <span v-else>-</span>
          </template>

          <template v-slot:[`item.is_approved_by_tsaheel_acc`]="{ item }">
            <v-icon v-if="item.is_approved_by_tsaheel_acc === 'نعم'" color="green">mdi-check-circle</v-icon>
            <span v-else>-</span>
          </template>
        </table-component>

        <OrderRequestSection v-if="this.$store.state.openOrderRequestSection" style="margin-top: 50px" />
      </div>
    </div>

    <div v-else style="display: flex; align-items: center; justify-content: center; margin-top: 40px">
      <LoadingMore />
    </div>

    <FundingManagerFilterDialog pageName="all" @fireSearch="searchRequest" />
    <OrderRequestDialog />
    <CallsDialog />
  </div>
</template>

<script>
import LoadingMore from "@/components/Charts/LoadingMore.vue";
import HeaderIcons from "@/views/funding_manager/Requests/HeaderIcons.vue";
import FundingManagerFilterDialog from "@/views/funding_manager/Requests/FundingManagerFilterDialog.vue";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import { formatDate } from "@/mixins/formatDate";
import OrderRequestDialog from "@/components/AdminComponent/OrderRequestDialog.vue";
import OrderRequestSection from "@/components/AdminComponent/OrderRequestSection.vue";
import AllSingleProcess from "./AllSingleProcess.vue";
import { axiosInstance } from "@/axios/config";

export default {
  name: "TasahelReports",
  components: {
    OrderRequestDialog,
    OrderRequestSection,
    FundingManagerFilterDialog,
    LoadingMore,
    HeaderIcons,
    AllSingleProcess,
    CallsDialog,
  },

  data() {
    return {
      allGetData: [],
      customers: [],
      search: '',
      selected_requests: [],
      pagination: {
        limit: 3,
        count: this.$store.state.searchedCount,
      },
      page: 1,
      selectedRows: [],
      allData: [],
      snackbar: {
        show: false,
        message: '',
        color: 'success'
      },
      showSelect: { default: false },
      copySupportRequests: [],
      loadMoreData: false,
      count: null,
      loading: false,
      selectId: null,
      allStatus: [],
      label: "",
      selectedItems: [],
      countPage: 1,
      natureRequestOptions: [
        { text: 'عقد', value: 'عقد' },
        { text: 'عقد شراء', value: 'عقد شراء' },
        { text: 'دفعة رهن', value: 'دفعة رهن' },
        { text: 'دفعة شراء', value: 'دفعة شراء' },
        { text: 'قرض شخصي', value: 'قرض شخصي' },
        { text: 'مبلغ إضافي', value: 'مبلغ إضافي' },
      ],
      headers: [
        { align: "center", value: "data-table-select", width: "40px" },
        { text: "رقم المعاملة", value: "id", width: "90px", align: "center" },
        { text: "التاريخ", value: "created_at", width: "110px", align: "center" },
        { text: "عميل", value: "customerName", align: "center", width: "130px" },
        { text: "الجوال", value: "CustomerMobile", align: "center", width: "110px" },
        { text: "نوع الخدمة", value: "type", align: "center", width: "130px" },
        { text: "مبلغ السداد", value: "mortCost", align: "center", width: "110px" },
        { text: "موظف خدمة العملاء", value: "customer_service_name", align: "center", width: "140px" },
        { text: "مسئول المبيعات", value: "userName", align: "center", width: "140px" },
        { text: "الاستشاري السابق", value: "prev_agent", align: "center", width: "140px" },
        { text: "الملاحظات", value: "accountcomment", align: "center", width: "180px" },
        { text: "رهن الوساطه", value: "mortgage_value", align: "center", width: "120px" },
        { text: "رهن تساهيل", value: "tsaheel_mortgage_value", align: "center", width: "120px" },
        { text: "تاريخ بداية المعاملة", value: "recived_date_report_mor", align: "center", width: "140px" },
        { text: "الي تاريخ", value: "to_date", align: "center", width: "120px" },
        { text: "المدة", value: "counter_report_mor", align: "center", width: "90px" },
        { text: "طبيعة المعاملة", value: "natureRequest", align: "center", width: "130px" },
        { text: "اعتماد محاسب الوساطة", value: "is_approved_by_wsata_acc", align: "center", width: "150px" },
        { text: "اعتماد محاسب تساهيل", value: "is_approved_by_tsaheel_acc", align: "center", width: "150px" },
        { text: "العمليات", value: "operations", align: "center", width: "100px" },
      ],

    };
  },

  watch: {
    page(val) {
      if (this.$store.state.isSearch === false && this.search == null) {
        this.getTableData(val);
      } else {
        this.searchRequest(val, "table");
      }
    },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getTableData(this.page);
        }
      },
    },
  },

  methods: {
    showMessage(message, type = 'success') {
      this.snackbar = {
        show: true,
        message,
        color: type
      };
    },

    canEdit(item) {
      const userRole = localStorage.getItem("role");
      return userRole == "8" &&
        item.is_approved_by_tsaheel_acc === 'لا' &&
        item.statusReq !== 26 &&
        item.statusReq !== 16;
    },

    canEditToDate(item) {
      const userRole = localStorage.getItem("role");
      return userRole == "8" &&
        item.statusReq !== 26 &&
        item.statusReq !== 16 &&
        !!item.recived_date_report_mor;
    },

    isValidDateValue(value) {
      return !!value && value !== '---' && /^\d{4}-\d{2}-\d{2}$/.test(value);
    },

    parseCounterDays(counter) {
      if (counter === null || counter === undefined || counter === '') return null;
      if (typeof counter === 'number') return counter;
      const match = String(counter).match(/\d+/);
      return match ? parseInt(match[0], 10) : null;
    },

    getEditableToDate(item) {
      if (this.isValidDateValue(item.to_date)) {
        return item.to_date;
      }

      const days = this.parseCounterDays(item.counter_report_mor);
      if (!item.recived_date_report_mor || days === null) {
        return null;
      }

      const startDate = new Date(`${item.recived_date_report_mor}T00:00:00`);
      startDate.setDate(startDate.getDate() + days);
      const year = startDate.getFullYear();
      const month = String(startDate.getMonth() + 1).padStart(2, '0');
      const day = String(startDate.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    formatDisplayToDate(item) {
      return this.getEditableToDate(item) || '---';
    },

    getLocalFieldName(field) {
      const fieldMap = {
        cust_name: "customerName",
      };

      return fieldMap[field] || field;
    },

    hasFieldChanged(item, field, value) {
      const localField = this.getLocalFieldName(field);
      return String(item?.[localField] ?? "") !== String(value ?? "");
    },

    updateLocalField(item, field, value) {
      this.$set(item, this.getLocalFieldName(field), value);
    },

    async updateField(item, field, value) {
      if (!item || !this.hasFieldChanged(item, field, value)) return;

      const previousValue = item[this.getLocalFieldName(field)];
      this.updateLocalField(item, field, value);

      try {
        const response = await axiosInstance.post(
          '/employee/accounting/updateField',
          { id: item.id, field, value },
          { headers: this.request_headers() }
        );

        if (response.data) {
          this.showMessage(response.data.message || 'تم التحديث بنجاح', 'success');
        } else {
          this.updateLocalField(item, field, previousValue);
          this.showMessage('حدث خطأ في التحديث', 'error');
        }
      } catch (error) {
        this.updateLocalField(item, field, previousValue);
        console.error('Update error:', error);
        this.showMessage(error.response?.data?.message || 'حدث خطأ في التحديث', 'error');
      }
    },

    async updateComment(item, value) {
      if (!item || !this.hasFieldChanged(item, "accountcomment", value)) return;

      const previousValue = item.accountcomment;
      this.updateLocalField(item, "accountcomment", value);

      try {
        const response = await axiosInstance.post(
          '/employee/accounting/updatecomm',
          { id: item.id, reqComm: value },
          { headers: this.request_headers() }
        );

        if (response.data) {
          this.showMessage('تم تحديث التعليق بنجاح', 'success');
        } else {
          this.updateLocalField(item, "accountcomment", previousValue);
          this.showMessage('حدث خطأ في التحديث', 'error');
        }
      } catch (error) {
        this.updateLocalField(item, "accountcomment", previousValue);
        console.error('Comment update error:', error);
        this.showMessage(error.response?.data?.message || 'حدث خطأ في التحديث', 'error');
      }
    },

    async updateStartDate(item, value) {
      if (!item || !this.hasFieldChanged(item, "recived_date_report_mor", value)) return;

      const previousValue = item.recived_date_report_mor;
      this.updateLocalField(item, "recived_date_report_mor", value);

      try {
        const response = await axiosInstance.post(
          '/employee/accounting/updatestartdate',
          { id: item.id, recived_date_report_mor: value },
          { headers: this.request_headers() }
        );

        if (response.data) {
          this.showMessage('تم تحديث تاريخ الاستلام بنجاح', 'success');
        } else {
          this.updateLocalField(item, "recived_date_report_mor", previousValue);
          this.showMessage('حدث خطأ في التحديث', 'error');
        }
      } catch (error) {
        this.updateLocalField(item, "recived_date_report_mor", previousValue);
        console.error('Start date update error:', error);
        this.showMessage(error.response?.data?.message || 'حدث خطأ في التحديث', 'error');
      }
    },

    async updateEndDate(item, value) {
      const currentValue = this.getEditableToDate(item);
      if (!item || currentValue === value) return;

      const previousValue = item.to_date;
      const previousCounter = item.counter_report_mor;
      this.updateLocalField(item, "to_date", value);

      try {
        const response = await axiosInstance.post(
          '/employee/accounting/updateenddate',
          { id: item.id, to_date: value },
          { headers: this.request_headers() }
        );

        if (response.data) {
          const counter = response.data?.payload?.counter ?? response.data?.counter;
          if (counter !== undefined && counter !== null) {
            this.$set(item, 'counter_report_mor', `${counter} يوم`);
          }
          this.showMessage('تم تحديث تاريخ الانتهاء بنجاح', 'success');
        } else {
          this.updateLocalField(item, "to_date", previousValue);
          this.$set(item, 'counter_report_mor', previousCounter);
          this.showMessage('حدث خطأ في التحديث', 'error');
        }
      } catch (error) {
        this.updateLocalField(item, "to_date", previousValue);
        this.$set(item, 'counter_report_mor', previousCounter);
        console.error('End date update error:', error);
        this.showMessage(error.response?.data?.message || 'حدث خطأ في التحديث', 'error');
      }
    },

    getUsersName(users, label, requestId) {
      this.allStatus = users;
      this.label = label;
      this.selectId = requestId;
    },

    handleBack() {
      this.$store.state.allData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.$store.state.followLoading = true;
      this.$store.state.isSearch = false;
      this.$store.state.back = false;
      this.getLoadTableData(1);
    },

    reloadPage() {
      this.$store.state.allData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.$store.state.followLoading = true;
      this.$store.state.isSearch = false;
      this.getLoadTableData(1);
      this.$store.state.startElement = [];
    },

    setTblData(res) {
      this.$store.state.tableData.push({
        id: res.id,
        isSelected: false,
        created_at: res.created_at ? formatDate(res.created_at) : "",
        type: res.type || "لا_يوجد",
        customerName: res.customer?.name || '',
        CustomerMobile: res.customer?.mobile || '',
        mortCost: res.prepayments?.mortCost || '',
        customer_service_name: res.customer_service_name? res.customer_service_name : '-',
        userName: res.user?.name || '',
        prev_agent: res.prev_agent || '',
        accountcomment: res.accountcomment || '',
        mortgage_value: res.real_estate?.mortgage_value || '',
        tsaheel_mortgage_value: res.real_estate?.tsaheel_mortgage_value || '',
        recived_date_report_mor: res.recived_date_report_mor || '',
        to_date: res.to_date && res.to_date !== '---' ? res.to_date : '',
        counter_report_mor: res.counter_report_mor || '',
        natureRequest: res.natureRequest || '',
        is_approved_by_wsata_acc: res.is_approved_by_wsata_acc == 1 ? "نعم" : "لا",
        is_approved_by_tsaheel_acc: res.is_approved_by_tsaheel_acc == 1 ? "نعم" : "لا",
        statusReq: res.statusReq,
        operations: res.sent_basket?.count || '',
      });
    },

    getTableData(count) {
      this.$store.state.tableData = [];
      this.loading = true;
      const pageNumber = Number(this.$store.state.counterOfShow);
      axiosInstance
        .get(`/v2/employee/Requests?type=tsaheelreports_under&page=${count}&per_page=${pageNumber}`, {
          headers: this.request_headers(),
        })
        .then((res) => {
          res.data.payload.data.forEach((item) => {
            this.setTblData(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error('Get table data error:', error);
          this.loading = false;
        });
    },

    searchRequest(page, type = 'table') {
      this.loading = true;
      this.$store.state.tableData = [];
      this.$store.state.bodySearch.delete("page");
      this.$store.state.bodySearch.append("page", page);
      let url = `/v2/employee/Requests/search?type=tsaheelreports_under&per_page=${this.$store.state.counterOfShow}`;
      axiosInstance
        .post(url, this.$store.state.bodySearch, { headers: this.request_headers() })
        .then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.searched,
          };
          res.data.payload.data.forEach((item) => {
            this.setTblData(item);
          });
        })
        .catch((error) => {
          console.error('Search error:', error);
          this.$store.state.allLoading = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.$store.state.allLoading = false;
          this.loading = false;
        });
    },

    getLoadTableData(page) {
      if (this.$store.state.allData.length === 0 || this.copySupportRequests.length === 0) {
        this.$store.state.allLoading = true;
      }
      this.loadMoreData = true;
      axiosInstance
        .get(`/v2/employee/Requests?type=tsaheelreports_under&page=${page}&per_page=${this.$store.state.counterOfShow}`)
        .then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.count_of_tsaheelreports_under,
          };
          res.data.payload.data.forEach((item) => {
            this.setTblData(item);
            item["starChecked"] = false;
          });
        })
        .catch((error) => {
          console.error('Load table data error:', error);
          this.$store.state.allLoading = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.$store.state.allLoading = false;
        });
    },
  },

  created() {
    this.$store.state.tableData = [];
    this.$store.state.back = false;
    this.$store.state.isSearch = false;
    this.$store.state.bodySearch = new FormData();
    this.getLoadTableData(1);
    this.$store.state.startElement = [];
    this.allLoading = false;
  },
};
</script>

<style scoped>
.table__view .v-btn:not(.v-btn--round).v-size--small {
  min-width: auto !important;
}

.editable-field {
  width: 100%;
  padding: 2px;
}

.editable-input,
.editable-textarea,
.editable-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #222;
  background-color: #f5f5f5;
  transition: all 0.2s;
}

.editable-textarea {
  resize: vertical;
  min-height: 50px;
  font-family: inherit;
}

.editable-select {
  cursor: pointer;
}

.editable-input:focus,
.editable-textarea:focus,
.editable-select:focus {
  outline: none;
  border-color: #441545;
  color: #222;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(68, 21, 69, 0.1);
}

.dark .editable-input,
.dark .editable-textarea,
.dark .editable-select {
  color: #f3f5f7;
  background-color: #312b41;
  border-color: #444;
  caret-color: #f3f5f7;
}

.dark .editable-input:focus,
.dark .editable-textarea:focus,
.dark .editable-select:focus {
  color: #f3f5f7;
  border-color: #a78bba;
  background-color: #3d354f;
  box-shadow: 0 0 0 2px rgba(167, 139, 186, 0.2);
}
</style>